

import extractCostParts from './extractCostParts';

export default function getCostRange(options) {
  const costsStrings = options.map((option) => option.cost);
  const costsParts = costsStrings.map((costStr) => extractCostParts(costStr));
  const { currencySymbol } = costsParts[0];
  const costs = costsParts.map((costPart) => costPart.cost);

  const minCost = Math.min(...costs);
  const maxCost = Math.max(...costs);

  return {
    minCost,
    maxCost,
    currencySymbol
  };
}